/**
 * @desc 获取商户支付能力
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** browserType */
  browserType:
    | 'COMMON'
    | 'WECHAT'
    | 'ALIPAY'
    | 'DING_TALK'
    | 'WECHAT_MINI_PROGRAM'
  /** @Min: 1.0 - @Max: null (until #1244 gets fixed) */
  detail: number
  /** orderNo */
  orderNo: string
  /** paymentSource */
  paymentSource: 'EXT_APP' | 'APP'
  /** sign */
  sign: string
  /** token */
  token: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/availablePaymentMethodList',
    params,
    method: 'get',
  })
}
